import firebase from "firebase";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDLEyumA-d86iaPVDfv0r4A3Xre4hX08wQ",
  authDomain: "tienda-anfora.firebaseapp.com",
  databaseURL: "https://tienda-anfora.firebaseio.com",
  projectId: "tienda-anfora",
  storageBucket: "anforastore",
  messagingSenderId: "145865545520",
  appId: "1:145865545520:web:3ff995aa95f8528ba49af5",
  measurementId: "G-L15LXRWN6Y"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const storageRef = storage.ref();
const auth = firebase.auth();

// firebase collections
// const categories = db.collection('categories');

export {
  firebase,
  db,
  storage,
  storageRef,
  auth
  // categories
}
